// ─────────────────────────────────────────────────────────────────────────────
// Customer Emails Actions
// ─────────────────────────────────────────────────────────────────────────────
// NgRx actions for the customerEmails store slice (per-customer email registry
// consumed by the company-profile "Extra Emails" section).
// Covers list, create, update, delete, and a clear-error helper.
// Single-row mutations only; backend Phase 21 explicitly omitted batch endpoints.
// ─────────────────────────────────────────────────────────────────────────────

import { createAction, props } from '@ngrx/store';
import { APIResponse } from 'src/app/core/models/api-response';
import { ICompanyEmail, ICreateCustomerEmailPayload, IStructuredApiError, IUpdateCustomerEmailPayload } from '../models/customer-email.models';

// ── Load customer emails ─────────────────────────────────────────────────────

export const LoadCustomerEmails = createAction('[ CustomerEmails ] - LoadCustomerEmails', props<{ customerId: number }>());
export const LoadCustomerEmailsSuccess = createAction(
  '[ CustomerEmails ] - LoadCustomerEmails Success',
  props<{ customerId: number; response: APIResponse<ICompanyEmail> }>(),
);
export const LoadCustomerEmailsError = createAction('[ CustomerEmails ] - LoadCustomerEmails Error', props<{ error: string }>());

// ── Create customer email ────────────────────────────────────────────────────

export const CreateCustomerEmail = createAction('[ CustomerEmails ] - CreateCustomerEmail', props<{ payload: ICreateCustomerEmailPayload }>());
export const CreateCustomerEmailSuccess = createAction('[ CustomerEmails ] - CreateCustomerEmail Success', props<{ email: ICompanyEmail }>());
export const CreateCustomerEmailError = createAction('[ CustomerEmails ] - CreateCustomerEmail Error', props<{ error: IStructuredApiError }>());

// ── Update customer email ────────────────────────────────────────────────────

export const UpdateCustomerEmail = createAction(
  '[ CustomerEmails ] - UpdateCustomerEmail',
  props<{ id: number; customerId: number; payload: IUpdateCustomerEmailPayload }>(),
);
export const UpdateCustomerEmailSuccess = createAction('[ CustomerEmails ] - UpdateCustomerEmail Success', props<{ email: ICompanyEmail }>());
export const UpdateCustomerEmailError = createAction(
  '[ CustomerEmails ] - UpdateCustomerEmail Error',
  props<{ error: IStructuredApiError; customerId: number }>(),
);

// ── Delete customer email ────────────────────────────────────────────────────

export const DeleteCustomerEmail = createAction('[ CustomerEmails ] - DeleteCustomerEmail', props<{ id: number; customerId: number }>());
export const DeleteCustomerEmailSuccess = createAction(
  '[ CustomerEmails ] - DeleteCustomerEmail Success',
  props<{ id: number; customerId: number }>(),
);
export const DeleteCustomerEmailError = createAction(
  '[ CustomerEmails ] - DeleteCustomerEmail Error',
  props<{ error: IStructuredApiError; customerId: number }>(),
);

// ── Misc ─────────────────────────────────────────────────────────────────────

export const ClearCustomerEmailsError = createAction('[ CustomerEmails ] - ClearError');
